import InvalidResetTokenScene from './InvalidResetTokenScene'
export default InvalidResetTokenScene